import { Button, Space } from "antd";
import { useState } from "react";

interface ButtonSwitchProps {
  buttons: string[];
  onSwitch?: (activeButton: string) => void;
}

export default function ButtonSwitch({ buttons, onSwitch }: ButtonSwitchProps) {
  const [activeButton, setActiveButton] = useState(buttons[0]); // Set the first button as active by default

  const handleSwitch = (button: string) => {
    setActiveButton(button);
    if (onSwitch) onSwitch(button); // Call the optional callback function when switching
  };

  return (
    <Space size="large">
      {buttons.map((button) => (
        <Button
          key={button}
          type={button === activeButton ? "primary" : "default"}
          onClick={() => handleSwitch(button)}
        >
          {button}
        </Button>
      ))}
    </Space>
  );
}
